import { supabase } from './supabase';

// Caller's profile.id is stable per session, so we cache it in module scope and
// invalidate on auth state change. profile.id ≠ auth.uid() since 0006 — use this
// helper anywhere code previously sent auth.uid() as a foreign key (author_id,
// user_id, target_user_id, etc.).

let cachedAuthUserId: string | null = null;
let cachedProfileId: string | null = null;
let inFlight: Promise<string> | null = null;

export async function getCurrentProfileId(): Promise<string> {
  const { data: userData, error: userError } = await supabase.auth.getUser();
  if (userError) throw new Error(userError.message);
  if (!userData.user) throw new Error('Нет активной сессии');
  const authUserId = userData.user.id;

  if (cachedAuthUserId === authUserId && cachedProfileId !== null) {
    return cachedProfileId;
  }

  if (inFlight !== null && cachedAuthUserId === authUserId) {
    return inFlight;
  }

  inFlight = (async (): Promise<string> => {
    const { data, error } = await supabase.rpc('current_profile_id');
    if (error) throw new Error(error.message);
    if (!data) throw new Error('Профиль не найден');
    cachedAuthUserId = authUserId;
    cachedProfileId = data;
    return data;
  })();

  try {
    return await inFlight;
  } finally {
    inFlight = null;
  }
}

export function clearProfileIdCache(): void {
  cachedAuthUserId = null;
  cachedProfileId = null;
  inFlight = null;
}

// Wire the cache to auth state changes once at module load — sign-out / sign-in
// must purge the previous user's profile id before any repo is called again.
supabase.auth.onAuthStateChange((event) => {
  if (event === 'SIGNED_OUT' || event === 'SIGNED_IN' || event === 'USER_UPDATED') {
    clearProfileIdCache();
  }
});
